module.exports = __webpack_public_path__ + "img/Tessellate02.e6dd4adb.png";